import { ActiveChannelRequest } from '@domain/channel';
import {
  BasePreset,
  BottleServicePreset,
  PRESET_TYPE_BOTTLE_SERVICE,
  PRESET_TYPE_GUEST_LIST,
  PRESET_TYPE_TICKET,
  TicketPreset,
} from '@domain/preset';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export interface FloorplanAdmissions {
  [PRESET_TYPE_BOTTLE_SERVICE]: BottleServicePreset[];
  [PRESET_TYPE_GUEST_LIST]: BasePreset[];
  [PRESET_TYPE_TICKET]: TicketPreset[];
}

export const getFloorplanPresetAdmissionsQueryKey = (floorplanId: string) => [
  QUERY_KEYS.getFloorplanPresetAdmissions,
  floorplanId,
];

const getFloorplanPresetAdmissions = async (floorplanId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/floorplan-presets/${floorplanId}/admission-presets`;

  const floorplanAdmissions: FloorplanAdmissions = await request({ url, method: RequestMethod.GET });

  for (let key = 0; key < floorplanAdmissions.bottleService.length; key++) {
    const admission = floorplanAdmissions.bottleService[key];
    const channelUrl = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offer-presets/${admission.id}/channels`;

    const channels: ActiveChannelRequest = await request({ url: channelUrl, method: RequestMethod.GET });

    floorplanAdmissions.bottleService[key] = {
      ...admission,
      channels: channels.channels,
      settings: {
        ...admission.settings,
        isForAllChannels: channels.isForAllChannels,
      },
    };
  }

  return floorplanAdmissions;
};

export const useGetFloorplanPresetAdmissions = (floorplanId: string) => {
  return useGenericQuery<FloorplanAdmissions, RequestError>(
    [QUERY_KEYS.getFloorplanPresetAdmissions, floorplanId],
    () => getFloorplanPresetAdmissions(floorplanId),
    {
      enabled: !!floorplanId,
    }
  );
};
